<template>
  <div>
    <el-collapse
        v-model="activeCollapseName"
        class="orderdetail-collapse"
        @change="collapseChange">
      <el-row :gutter="40">
        <el-col :span="24">
          <el-collapse-item
              v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.Pending.ORDER)"
              title="注文"
              name="order">
            <div v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.Pending.NEW)">
              <div class="pending-table-header">
                保留設定
              </div>
              <BaseTableDetail
                  :table-set-list="registrationOrderLabel"
                  :display-item="getRegistrationOrderData"
                  :editable="editableRegistration"
                  validate-scope="order-registration"
                  class="pending-registraration" />
              <div class="show-btn">
                <BaseButton
                    :disabled="$isFunctionDisabled(define.PermissionKeys.Order.Detail.Pending.NEW)"
                    @click="onRegistration(null,null)">
                  登録
                </BaseButton>
              </div>
            </div>
            <div class="pending-table-header">
              保留設定状況
            </div>
            <BaseTableList
                ref="TableList"
                :table-set-list="pendinglist"
                :display-items="pendingByOrder"
                :editable="editablePendingList"
                :empty-text="emptyText"
                class="pending-table" />
            <div v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.Pending.EDIT)">
              <div v-if="isExistOrderList()">
                <BaseTableDetail
                    :table-set-list="pendingCancellation"
                    :display-item="cancellationOrderData"
                    :editable="editableCancellation"
                    validate-scope="order-cancellation"
                    class="pending-cancellaration" />
                <div class="show-btn">
                  <BaseButton
                      :disabled="$isFunctionDisabled(define.PermissionKeys.Order.Detail.Pending.EDIT)"
                      @click="onCancellation(null,null)">
                    解除
                  </BaseButton>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-col>
      </el-row>
      <el-row
          v-for="(shipment, i) in orderData.shipments"
          :key="`shipment-${i}`"
          :gutter="40">
        <el-col :span="24">
          <el-collapse-item
              v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.Pending.SHIPMENT)"
              :id="`shipment-${i}`"
              :title="`配送先${i + 1} (配送番号： ${shipment.shipmentId})`"
              :name="`shipment-${i}`">
            <div v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.Pending.NEW)">
              <div class="pending-table-header">
                保留設定
              </div>
              <BaseTableDetail
                  :table-set-list="registrationShipmentLabel"
                  :display-item="registrationShipmentData[i]"
                  :editable="editableRegistration"
                  :validate-scope="`shipment${i}-registration`"
                  class="pending-registraration" />
              <div class="show-btn">
                <BaseButton
                    :disabled="$isFunctionDisabled(define.PermissionKeys.Order.Detail.Pending.NEW)"
                    @click="onRegistration(i, shipment.shipmentId)">
                  登録
                </BaseButton>
              </div>
            </div>
            <div class="pending-table-header">
              保留設定状況
            </div>
            <BaseTableList
                ref="TableList"
                :table-set-list="pendinglist"
                :display-items="pendingByShipment[i]"
                :editable="editablePendingList"
                :empty-text="emptyText"
                class="pending-table" />
            <div v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.Pending.EDIT)">
              <div v-if="isExistShipmentList(i)">
                <BaseTableDetail
                    :table-set-list="pendingCancellation"
                    :display-item="cancellationShipmentData[i]"
                    :editable="editableCancellation"
                    :validate-scope="`shipment${i}-cancellation`"
                    class="pending-cancellaration" />
                <div class="show-btn">
                  <BaseButton
                      :disabled="$isFunctionDisabled(define.PermissionKeys.Order.Detail.Pending.EDIT)"
                      @click="onCancellation(i, shipment.shipmentId)">
                    解除
                  </BaseButton>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-col>
      </el-row>
    </el-collapse>
  </div>
</template>

<style scoped>
.pending-table {
  margin-top: 0px;
}
.pending-registraration {
  margin-top: 20px;
}
.pending-cancellaration {
  margin-top: 20px;
}
.pending-table-header {
  height: 56px;
  line-height: 56px;
  padding-left: 45px;
  color: #181d62;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #c7d3d9;
}
.show-btn {
  padding: 15px;
}
</style>

<script>
import _ from 'lodash'
import * as define from '@/define'
import * as config from '@/config'
import * as pendingQuery from '@/queries/pending'
import common from '@/utils/common'
import message from '@/utils/message'
import BaseButton from '@/components/atoms/BaseButton'
import BaseTableList from '@/components/molecules/BaseTableList'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

export default {
  name: 'OrderDetailPending',
  components: {
    BaseButton,
    BaseTableList,
    BaseTableDetail
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  beforeRouteLeave (to, from, next) {
    // 別ページへ移動する場合、storeの一覧情報を削除する
    this.$store.dispatch({
      type: 'set',
      states: {
      }
    })
    next()
  },
  props: {
    orderData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      activeCollapseName: [],
      pendingData: [],
      pendingByOrder: [],
      pendingByShipment: [],
      registrationOrderData: { type: null, pendReason: null },
      registrationShipmentData: this.orderData.shipments ? this.orderData.shipments.map(() => ({ type: null, pendReason: null })) : [],
      cancellationOrderData: { unpendReason: null },
      cancellationShipmentData: this.orderData.shipments ? this.orderData.shipments.map(() => ({ unpendReason: null })) : []
    }
  },
  computed: {
    define: () => define,
    getRegistrationOrderData () {
      return this.registrationOrderData
    },
    emptyText () {
      return 'データなし'
    },
    activeCollapseKey () {
      return 'orderDetailPendingCollapse'
    },
    registrationOrderLabel () {
      return [
        {
          label: '種別',
          properties: [
            {
              path: 'type', type: 'Number', elementType: ELEMENT_TYPE.RADIO_BUTTON, editableId: 'type',
              validateRule: 'required|typeRequired', validateAs: '種別',
              funcId: define.PermissionKeys.Order.Detail.Pending.NEW,
              selectCode: 'z_groovy_pending.type_order', codeName: 'z_groovy_pending.type_order'
            }
          ]
        },
        {
          label: '修正理由',
          properties: [
            {
              path: 'pendReason', type: 'String', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA, editableId: 'pendReason',
              validateRule: 'max:256', validateAs: '修正理由',
              funcId: define.PermissionKeys.Order.Detail.Pending.NEW
            }
          ]
        }
      ]
    },
    registrationShipmentLabel () {
      return [
        {
          label: '種別',
          properties: [
            {
              path: 'type', type: 'Number', elementType: ELEMENT_TYPE.RADIO_BUTTON, editableId: 'type',
              validateRule: 'required', validateAs: '種別',
              funcId: define.PermissionKeys.Order.Detail.Pending.NEW,
              selectCode: 'z_groovy_pending.type_ship', codeName: 'z_groovy_pending.type_ship'
            }
          ]
        },
        {
          label: '修正理由',
          properties: [
            {
              path: 'pendReason', type: 'String', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA, editableId: 'pendReason',
              validateRule: 'max:256', validateAs: '修正理由',
              funcId: define.PermissionKeys.Order.Detail.Pending.NEW
            }
          ]
        }
      ]
    },
    pendinglist () {
      return [
        { label: '解除対象', path: 'checkbox', type: 'Boolean',
          width: 100, elementType: ELEMENT_TYPE.CHECK_BOX,
          editableId: 'checkbox', editableCondition: this.editableSelection,
          funcId: define.PermissionKeys.Order.Detail.Pending.EDIT
        },
        { label: '状態', path: 'status', type: 'String',
          codeName: 'z_groovy_pending.status',
          funcId: define.PermissionKeys.Order.Detail.Pending.STATUS },
        { label: '日時', path: 'pendingAt', type: 'Date',
          funcId: define.PermissionKeys.Order.Detail.Pending.PENDING_AT },
        { label: '登録者', path: 'createdBy', type: 'String',
          funcId: define.PermissionKeys.Order.Detail.Pending.CREATED_BY },
        { label: '種別', path: 'type', type: 'String',
          codeName: 'z_groovy_pending.type',
          funcId: define.PermissionKeys.Order.Detail.Pending.TYPE },
        { label: '修正理由', path: 'pendReason', type: 'String',
          funcId: define.PermissionKeys.Order.Detail.Pending.PEND_REASON },
        { label: '更新者', path: 'updatedBy', type: 'String',
          funcId: define.PermissionKeys.Order.Detail.Pending.UPDATE_BY },
        { label: '更新日時', path: 'updatedAt', type: 'Date',
          funcId: define.PermissionKeys.Order.Detail.Pending.UPDATE_AT },
        { label: '解除理由', path: 'unpendReason', type: 'String',
          funcId: define.PermissionKeys.Order.Detail.Pending.UNPEND_REASON }
      ]
    },
    pendingCancellation () {
      return [
        {
          label: '解除理由',
          properties: [
            {
              path: 'unpendReason', type: 'String', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA, editableId: 'unpendReason',
              validateRule: 'max:256', validateAs: '解除理由',
              funcId: define.PermissionKeys.Order.Detail.Pending.EDIT
            }
          ]
        }
      ]
    },
    editableRegistration () {
      return { type: true, pendReason: true }
    },
    editableCancellation () {
      return { unpendReason: true }
    },
    editablePendingList () {
      return { checkbox: true }
    }
  },
  watch: {
    async orderData (val) {
      // 注文情報が更新された場合
      // 登録情報初期化
      this.refreshList()
      // 保留設定情報取得
      await this.getPendingData()

      // 保留設定(注文単位)の情報取得
      this.pendingByOrder = (this.pendingData).filter((x) => (x.shipmentId == null || x.shipmentId == ''))
      for (let idx in this.pendingByOrder) {
        this.pendingByOrder[idx].checkbox = false
      }
      // 保留設定(配送単位)の情報取得
      for (let i in this.orderData.shipments) {
        this.pendingByShipment[i] = (this.pendingData).filter((x) => x.shipmentId === this.orderData.shipments[i].shipmentId)
        for (let j in this.pendingByShipment[i]) {
          this.pendingByShipment[i][j].checkbox = false
        }
      }
    },
    pendingData (val) {
      // 保留設定情報が更新された場合
      // 保留設定(注文単位)の情報取得
      this.pendingByOrder = (this.pendingData).filter((x) => (x.shipmentId == null || x.shipmentId == ''))
      for (let idx in this.pendingByOrder) {
        this.pendingByOrder[idx].checkbox = false
      }
      // 保留設定(配送単位)の情報取得
      for (let i in this.orderData.shipments) {
        this.pendingByShipment[i] = (this.pendingData).filter((x) => x.shipmentId === this.orderData.shipments[i].shipmentId)
        for (let j in this.pendingByShipment[i]) {
          this.pendingByShipment[i][j].checkbox = false
        }
      }
    }
  },
  beforeUpdate () {
  },
  async created () {
    try {
      this.$loadingService.show()
      // 保留設定情報取得
      await this.getPendingData()
      // store情報設定
      this.$store.dispatch({
        type: 'set',
        states: {
        }
      })
      const activeCollapse = common.getLocalStorage(this.activeCollapseKey)
      this.activeCollapseName = activeCollapse ? activeCollapse.split(',') : []
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  methods: {
    editableSelection (row) {
      return row.status
    },
    isExistOrderList () {
      return this.pendingByOrder ? (this.pendingByOrder.length > 0) : false
    },
    isExistShipmentList (i) {
      return this.pendingByShipment[i] ? (this.pendingByShipment[i].length > 0) : false
    },
    async getPendingData () {
      try {
        this.$loadingService.show()
        const site = this.orderData.site ? this.orderData.site : null
        if (site === null) {
          // console.log('site is null')
          return
        }
        let param = common.addGraphQlCondition(pendingQuery.GRAPH_QL_QUERY_PENDING_LIST,
          { siteCode: this.orderData.site.code, orderNo: this.orderData.orderNo })
        const res = await common.postGraphQl(param)
        this.pendingData = (common.getValueByPath(res.data, 'data.pendings') || [])
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    onRegistration (index, shipmentId) {
      let validateScope = ''

      if (shipmentId === null) {
        if (this.registrationOrderData.type == null) {
          this.$notify.error('種別を選択してください')
          return
        }
        validateScope = 'order-registration'
      } else {
        if (this.registrationShipmentData[index].type == null) {
          this.$notify.error('種別を選択してください')
          return
        }
        validateScope = `shipment${index}-registration`
      }
      this.$validator.validateAll(validateScope).then(result => {
        if (result) {
          this.$confirm(
            '登録しますか？',
            define.MESSAGE_TITLE,
            {
              confirmButtonText: 'はい',
              cancelButtonText: 'いいえ',
              type: 'warning'
            }
          ).then(() => {
            // 登録・更新API呼び出し
            this.registrationPendingData(index, shipmentId)
          }).catch(() => {})
        }
      })
    },
    onCancellation (index, shipmentId) {
      let validateScope = ''

      if (shipmentId === null) {
        if (!(this.pendingByOrder.filter((x) => x.checkbox === true).length)) {
          this.$notify.error('解除対象項目を選択してください')
          return
        }
        validateScope = 'order-cancellation'
      } else {
        if (!(this.pendingByShipment[index].filter((x) => x.checkbox === true).length)) {
          this.$notify.error('解除対象項目を選択してください')
          return
        }
        validateScope = `shipment${index}-cancellation`
      }
      this.$validator.validateAll(validateScope).then(result => {
        if (result) {
          this.$confirm(
            '解除しますか？',
            define.MESSAGE_TITLE,
            {
              confirmButtonText: 'はい',
              cancelButtonText: 'いいえ',
              type: 'warning'
            }
          ).then(() => {
            // 解除用API呼び出し
            this.cancellationPendingData(index, shipmentId)
          }).catch(() => {})
        }
      })
    },
    /**
     * collapse の 開閉状態を localStorage に保存します。
     */
    collapseChange: function () {
      common.setLocalStorage(this.activeCollapseKey, this.activeCollapseName.join())
      this.activeCollapseName = common.getLocalStorage(this.activeCollapseKey).split(',')
    },
    async registrationPendingData (index, shipmentId) {
      try {
        this.$loadingService.show()
        await this.registrationPendingDataApi(index, shipmentId)
        this.isChanged = false
        this.$notify.success('登録しました。')
        this.refreshList()
        this.$emit('requestUpdate')
      } catch (error) {
        const data = _.get(error, 'response.data')
        if (data == null) {
          common.addError(error, { msg: message.MSG_502() })
        } else {
          common.addError(error, { msg: message.MSG_566() })
        }
        this.$notify.error({ error: error })
      } finally {
        this.$loadingService.close()
      }
    },
    async cancellationPendingData (index, shipmentId) {
      try {
        this.$loadingService.show()
        await this.cancellationPendingDataApi(index, shipmentId)
        this.isChanged = false
        this.$notify.success('解除しました。')
        this.refreshList()
        this.$emit('requestUpdate')
      } catch (error) {
        const data = _.get(error, 'response.data')
        if (data == null) {
          common.addError(error, { msg: message.MSG_502() })
        } else {
          common.addError(error, { msg: message.MSG_567() })
        }
        this.$notify.error({ error: error })
      } finally {
        this.$loadingService.close()
      }
    },
    async registrationPendingDataApi (index, shipmentId) {
      let url
      let method
      let data
      let heads = {}

      heads = {}
      url = config.PENDING_URL
      method = 'post'
      data = this.buildRegistrationRequest(index, shipmentId)

      // console.log('registrationPendingDataApi')
      // console.log('url', url)
      // console.log('method', method)
      // console.log('data', data)
      // console.log('heads', heads)
      const response = await common.apiAxios(url, { method, data, heads })
      return response
    },
    buildRegistrationRequest (index, shipmentId) {
      let requestBody = {}
      if (index === null) {
        requestBody = {
          pending: {
            latestOrderRefid: null,
            siteCode: this.orderData.site.code,
            orderNo: this.orderData.orderNo,
            shipmentId: null,
            type: this.registrationOrderData.type,
            pendReason: this.registrationOrderData.pendReason ? this.registrationOrderData.pendReason : null
          }
        }
      } else {
        requestBody = {
          pending: {
            latestOrderRefid: null,
            siteCode: this.orderData.site.code,
            orderNo: this.orderData.orderNo,
            shipmentId: shipmentId,
            type: this.registrationShipmentData[index].type,
            pendReason: this.registrationShipmentData[index].pendReason ? this.registrationShipmentData[index].pendReason : null
          }
        }
      }
      return requestBody
    },
    async cancellationPendingDataApi (index, shipmentId) {
      let url
      let method
      let data
      let heads = {}

      heads = this.buildCancellationHeads(index, shipmentId)
      url = config.PENDING_URL
      method = 'post'
      data = this.buildCancellationRequest(index, shipmentId)

      // console.log('cancellationPendingDataApi')
      // console.log('url', url)
      // console.log('method', method)
      // console.log('data', data)
      // console.log('heads', heads)
      const response = await common.apiAxios(url, { method, data, heads })
      return response
    },
    buildCancellationHeads (index, shipmentId) {
      let heads = {}
      return heads
    },
    buildCancellationRequest (index, shipmentId) {
      let requestBody = {}
      if (index === null) {
        requestBody = {
          pending: {
            ids: (this.pendingByOrder.filter((x) => x.checkbox === true)).map((row) => row.id),
            unpendReason: this.cancellationOrderData.unpendReason ? this.cancellationOrderData.unpendReason : null,
            lastUpdatedAt: (this.pendingByOrder.filter((x) => x.checkbox === true)).map((row) => row.updatedAt)
          }
        }
      } else {
        requestBody = {
          pending: {
            ids: (this.pendingByShipment[index].filter((x) => x.checkbox === true)).map((row) => row.id),
            unpendReason: this.cancellationShipmentData[index].unpendReason ? this.cancellationShipmentData[index].unpendReason : null,
            lastUpdatedAt: (this.pendingByShipment[index].filter((x) => x.checkbox === true)).map((row) => row.updatedAt)
          }
        }
      }
      return requestBody
    },
    refreshList () {
      this.registrationOrderData = { type: null, pendReason: null }
      this.registrationShipmentData = this.orderData.shipments ? this.orderData.shipments.map(() => ({ type: null, pendReason: null })) : []
      this.cancellationOrderData = { unpendReason: null }
      this.cancellationShipmentData = this.orderData.shipments ? this.orderData.shipments.map(() => ({ unpendReason: null })) : []

      for (let idx in this.pendingByOrder) {
        this.pendingByOrder[idx].checkbox = false
      }

      for (let i in this.orderData.shipments) {
        for (let j in this.pendingByShipment[i]) {
          this.pendingByShipment[i][j].checkbox = false
        }
      }
    }
  }
}
</script>
